import './styles.scss';

import Button from '@/common/Button';
import HasPermission from '@/components/HasPermission';

type CategoriesHeaderProps = {
  onClick: () => void;
};

export const CategoriesHeader = ({ onClick }: CategoriesHeaderProps) => {
  return (
    <div className="CategoriesHeader">
      <div className="CategoriesHeader-TitleGroup">
        <h1 className="CategoriesHeader-Title text-primary">Checklist Categories</h1>
        <p className="CategoriesHeader-Subtitle text-gray">
          Group training items into weighted categories that total 100% of the driver readiness score.
        </p>
      </div>
      <HasPermission name="allowEditTrainingSettings">
        <Button type="button" className="CategoriesHeader-AddButton" onClick={onClick}>
          <i className="sv sv-plus-square" aria-hidden="true" />
          Add Category
        </Button>
      </HasPermission>
    </div>
  );
};
